goog.provide('el8.tourguide.chartInfoSplash');

goog.require('el8.app.pageLayout');
goog.require('el8.tourguide.InfoSplash');
goog.require('el8.template.tourguide.chartInfoSplash');

/**
 * Displays an overview of appchart's navigational elements.
 */
el8.tourguide.chartInfoSplash = (function() {

    var that = new el8.tourguide.InfoSplash({
        name: 'chart',
        contentFn: el8.template.tourguide.chartInfoSplash.content,
        UILayoutFn: function() { return el8.app.pageLayout; }
    });

    var STD_RIGHT_TOP_OFFSET = 75;
    var STD_DIST_BOTTOM = 50;  // standard distance from bottom of page
    var STD_RIGHT_WIDTH_FN = function() {
        return Math.min(
            $('#chart-feed-contents').width() - 5,
            $(window).width() - $('#refBoardContainer').width() - 20
        );
    };

    that.addBlock({
        anchorSelector: '#refBoardContainer',
        contentFn: el8.template.tourguide.chartInfoSplash.patientProfileBlock,
        heightFn: function($elt) {
            return $(window).height() - STD_DIST_BOTTOM - STD_RIGHT_TOP_OFFSET;
        },
        widthFn: function($elt) {
            return $elt.width() - 50;
        },
        topOffset: function($elt) {
            return STD_RIGHT_TOP_OFFSET - $elt.offset().top;
        },
        leftOffset: 20
    });
    that.addBlock({
        anchorSelector: '#chart-write-see-bar',
        contentFn: el8.template.tourguide.chartInfoSplash.writeSeeBarBlock,
        heightFn: function($elt) {
            return $elt.height() + 5;
        },
        widthFn: STD_RIGHT_WIDTH_FN,
        topOffset: -5,
        leftOffset: 2
    });
    that.addBlock({
        anchorSelector: '#main-feed-container',
        contentFn: el8.template.tourguide.chartInfoSplash.chartFeedBlock,
        heightFn: function($elt) {
            return $(window).height() - STD_DIST_BOTTOM - $elt.offset().top - 25;
        },
        widthFn: STD_RIGHT_WIDTH_FN,
        topOffset: 25,
        leftOffset: 5
    });
    if (el8Globals.TEASE) {
        var super_hide = that.hide;
        that.hide = function() {
            super_hide.call(that);
            $(document).trigger('chart-splash-close');
        };
    }

    return that;
})();


